import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, Row, Typography, UploadFile, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import SettingFactoryForm from "./SettingFactory";
// uuid
import { v4 as uuidv4, validate } from "uuid";
import { useUpdateFactory } from "hooks/useAuth";
import { getAuthProfile } from "services/authAPI";
import { setProfileAndContact } from "store/slices/authSlice";
import { useAppDispatch } from "store";
import { useGetFactoryDataById } from "hooks/useFactory";
import { DepartmentFactory, InputUpdateFactory } from "services/interface";

type Location = {
  lat: number;
  lng: number;
}

const SettingFactory = () => {
  const [avatar, setAvatar] = useState<UploadFile[] | undefined>([]);

  const [location, setLocation] = useState<Location>({
    lat: 13.736717,
    lng: 100.523186,
  });

  const navigate = useNavigate();
  const { contact, profile } = useAppSelector((state) => state.auth);

  const { data, isLoading, isError, refetch } = useGetFactoryDataById(profile?.user.role.ref_id ?? "");

  const { mutate, isPending } = useUpdateFactory();

  const [form] = Form.useForm();

  const dispatch = useAppDispatch();

  const onFinish = (values: any) => {
    console.log(values);
    console.log("location", location);
    console.log(contact?.id);

    let retail_type: number[] = []

    if (values.retail_type.length > 0) {
      retail_type = values.retail_type.map((item: any) => {
        return parseInt(item)
      })
    }

    const updateFactoryInput: InputUpdateFactory = {
      image: values.image[0].url,
      product_description: values.product_description,
      category_id: values.category,
      factory_type: values.factory_type,
      parent_id: values.parent_id ?? '',
      department: retail_type,
      address: {
        line_1: values.line_1.trim(),
        line_2: '',
        sub_district_id: values.sub_district_id,
        district_id: values.district_id,
        province_id: values.province_id,
        post_code: values.zip_code,
        latitude: location.lat.toString(),
        longitude: location.lng.toString(),
        zip_code: values.zip_code
      },
      id: data?.factory?.id ?? '',
      name: values.name.trim()
    }

    console.log("updateFactoryInput:::::-->", updateFactoryInput);

    mutate(updateFactoryInput, {
      onSuccess: () => {
        message.success("แก้ไขโรงพยาบาลสำเร็จ");
        getAuthProfile()
          .then((res) => {
            if (res.status === "success") {
              dispatch(
                setProfileAndContact({
                  profile: res.profile,
                  contact: res.contact,
                })
              );
            }
          })
      },
      onError: () => {
        message.error("แก้ไขโรงพยาบาลไม่สำเร็จ");
      },
    });

  };

  useEffect(() => {
    if (data) {
      if (contact?.image_url) {
        setAvatar([
          {
            uid: "uuid",
            name: "รูปโรงพยาบาล",
            url: data?.factory?.image_url,
          },
        ]);
      } else {
        setAvatar(undefined);
      }
      setLocation({
        lat: data.factory.address_fac?.gps?.latitude ?? 13.736717,
        lng: data.factory.address_fac?.gps?.longitude ?? 100.523186,
      });


      //retail_type convert to array number
      const retail_type = data.factory.department.map((item: DepartmentFactory) => {
        return parseInt(item.id.toString(), 10)
      })

      form.setFieldsValue({
        name: data.factory.name,
       // category: data.factory.category,
        address: data.factory.address,
        line_1: data.factory.address_fac?.line_1 ?? "",
        zip_code: data.factory.address_fac?.zip_code ?? "",
        sub_district_id: data.factory.address_fac?.sub_district_id ?? "",
        district_id: data.factory.address_fac?.district_id ?? "",
        province_id: data.factory.address_fac?.province_id ?? "",
        parent_id: data.factory.parent_id ?? "",
        factory_type: data.factory.factory_type ?? "",
        retail_type: retail_type,
        image: [
          {
            uid: "",
            name: "รูปโรงพยาบาล",
            status: "done",
            id: "",
            url: data.factory.image_url,
          },
        ],
      });
    }
  }, [data]);

  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/settings");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>ตั้งค่าโรงพยาบาล</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <WrapperAll>
              <SettingFactoryForm
                form={form}
                onFinish={onFinish}
                avatar={avatar}
                address_fac={contact?.address_fac}
                location={location}
                setLocation={setLocation}
              />
            </WrapperAll>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SettingFactory;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: #efefef;
`;
